import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReviewRmsPlanSummaryComponent } from '../../../../components/review-content/review-rms-plan-summary/review-rms-plan-summary.component';

@Component({
  selector: 'rms-plan-summary-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewRmsPlanSummaryComponent
  ],
  templateUrl: './rms-plan-summary-submission.component.html',
  styleUrl: './rms-plan-summary-submission.component.css'
})
export class RmsPlanSummarySubmissionComponent {

  @Input() rmsPlanSummaryData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.rmsPlanSummaryData) {
      this.currentCaseId = this.rmsPlanSummaryData.case_id;
    }
  }

  submitRmsPlanSummary(): void {
    this.onSaveSection3.emit({});
  }
}
